import script from './component-lib.esm4.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    ref: "container",
    staticClass: "site-container site-container--preview",
    class: _vm.classes,
    style: _vm.containerStyles
  }, [_c('div', {
    staticClass: "site-bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "site",
    class: {
      'site--has-social': _vm.socialAccounts.length > 0 && (!_vm.profile.site_social_position || _vm.profile.site_social_position === 'bottom'),
      'site--hide-branding': _vm.profile.site_hide_branding
    }
  }, [_c('div', {
    staticClass: "site__article"
  }, [_vm.showSiteHeader ? _c('div', {
    staticClass: "site__header",
    class: _vm.siteHeaderClasses
  }, [!_vm.profile.site_hide_profile_image ? _c('div', {
    staticClass: "site__header__img"
  }, [_c('img', {
    staticClass: "site__profile-img",
    class: {
      'site__profile-img--has-border': _vm.profile.site_profile_image_border
    },
    attrs: {
      "src": _vm.profileImage,
      "alt": _vm.profile.username + ' - Profile Picture',
      "height": "100",
      "width": "100"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "site__header__content"
  }, [!_vm.profile.site_hide_intro_title ? _c('h1', {
    staticClass: "site__username"
  }, [_vm._v("\n            " + _vm._s(_vm.username) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "site__location"
  }, [_vm.profile.site_location ? _c(_vm.locationComponent, _vm._b({
    tag: "component"
  }, 'component', _vm.locationAttrs, false), [_c('MapMarkerIcon'), _vm._v("\n              " + _vm._s(_vm.profile.site_location) + "\n            ")], 1) : _vm._e()], 1), _vm._v(" "), _vm.profile.site_intro_text ? _c('p', {
    staticClass: "site__intro"
  }, [_vm._v("\n            " + _vm._s(_vm.profile.site_intro_text) + "\n          ")]) : _vm._e(), _vm._v(" "), _vm.socialAccounts.length > 0 && _vm.profile.site_social_position === 'top' ? _c('SocialAccounts', {
    attrs: {
      "social-accounts": _vm.socialAccounts,
      "is-top": ""
    }
  }) : _vm._e()], 1)]) : _c('div', [_c('h1', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.username))]), _vm._v(" "), _vm.socialAccounts.length > 0 && _vm.profile.site_social_position === 'top' ? _c('SocialAccounts', {
    attrs: {
      "social-accounts": _vm.socialAccounts,
      "is-top": ""
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "site__links"
  }, [_vm._t("beforeLinks"), _vm._v(" "), _vm._t("default"), _vm._v(" "), !_vm.$slots.default ? [_vm._l(_vm.links, function (link) {
    return [_vm.checkLinkEnabled(link) ? _c(_vm.getLinkType(link), {
      key: link._id.$oid,
      ref: "linkRefs",
      refInFor: true,
      tag: "component",
      attrs: {
        "link": link
      }
    }) : _vm._e()];
  })] : _vm._e(), _vm._v(" "), _vm._t("afterLinks")], 2), _vm._v(" "), _vm.socialAccounts.length > 0 && (!_vm.profile.site_social_position || _vm.profile.site_social_position === 'bottom') ? _c('SocialAccounts', {
    attrs: {
      "social-accounts": _vm.socialAccounts
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "site__footer"
  }, [_c('a', {
    staticClass: "site__footer-logo",
    class: {
      'sr-only': _vm.profile.site_hide_branding
    },
    attrs: {
      "href": "#",
      "aria-label": "Campsite.bio"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('Logo', _vm._b({
    attrs: {
      "size": "25"
    }
  }, 'Logo', _vm.logoProps, false))], 1)])], 1)])]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-6c8f1a5c_0", {
    source: ".site-container[data-v-6c8f1a5c]{background:#fff;background:var(--p-bg-color);color:var(--p-text-color);font:400 18px/1.4 var(--p-font-family);min-height:100%;padding-left:.925rem;padding-right:.925rem;height:100%;max-height:100%;overflow-y:auto;overflow-x:hidden;scrollbar-width:none}.site-container--has-gradient[data-v-6c8f1a5c]{background:var(--p-bg-gradient)}.site-container--has-animated-gradient[data-v-6c8f1a5c]{background-size:400% 400%;animation:gradient-data-v-6c8f1a5c 15s ease infinite}@keyframes gradient-data-v-6c8f1a5c{0%{background-position:0 0}50%{background-position:100% 100%}100%{background-position:0 0}}.site[data-v-6c8f1a5c]{min-height:100%;position:relative;padding-bottom:65px}.site-bg[data-v-6c8f1a5c]{left:0;height:100%;position:absolute;pointer-events:none;top:0;width:100%}.site-container--has-bg-image .site-bg[data-v-6c8f1a5c]{background-image:var(--bg-mobile-src);background-size:cover;background-position:center}@media (min-width:544px){.site-container--has-bg-image .site-bg .site-bg[data-v-6c8f1a5c]{background-image:var(--bg-tablet-src)}}@media (min-width:992px){.site-container--has-bg-image .site-bg .site-bg[data-v-6c8f1a5c]{background-image:var(--bg-desktop-src)}}.site-container--has-bg-pattern[data-v-6c8f1a5c]{background-image:var(--p-bg-pattern);background-repeat:repeat}.site--hide-branding[data-v-6c8f1a5c]{padding-bottom:18px}.site__article[data-v-6c8f1a5c]{max-width:650px;margin:0 auto}.site__header[data-v-6c8f1a5c]{text-align:center;padding-top:3rem;position:relative}.site__header--align-left[data-v-6c8f1a5c]{display:flex;gap:1rem;margin-bottom:1.5rem;padding-top:2.5rem;text-align:left}.site__header--align-left[data-v-6c8f1a5c] .site__footer-social{justify-content:flex-start;margin-left:calc(-1 * var(--icon-padding));margin-bottom:0;margin-top:.5rem;column-gap:.425rem;row-gap:.125rem}.site__header--align-left[data-v-6c8f1a5c] .site__footer-social a{font-size:1.5rem}.site__header--has-profile-image[data-v-6c8f1a5c]:not(.site__header--align-left){padding-top:2rem}.site__header__img[data-v-6c8f1a5c]{flex-shrink:0}.site__profile-img[data-v-6c8f1a5c]{background:#fff;border:none;border-radius:50%;display:inline-block;object-fit:cover;height:100px;width:100px;margin-bottom:.325rem}.site__header--align-left .site__profile-img[data-v-6c8f1a5c]{height:70px;width:70px}.site__profile-img--has-border[data-v-6c8f1a5c]{border:.125rem solid var(--p-image-border-color)}.site__header--align-left .site__header__content[data-v-6c8f1a5c]{flex-grow:1}.site__intro[data-v-6c8f1a5c],.site__location[data-v-6c8f1a5c],.site__username[data-v-6c8f1a5c]{margin:.325rem 0}.site__username[data-v-6c8f1a5c]{color:var(--p-title-color);font-weight:var(--p-title-font-weight);font-family:var(--p-title-font-family);font-size:1.325rem;line-height:1.25;margin-bottom:.425rem}.site__header--align-left .site__username[data-v-6c8f1a5c]{font-size:1.125rem}.site__intro[data-v-6c8f1a5c]{color:var(--p-text-color);font-weight:400;font-size:.925rem;line-height:1.6;margin-left:auto;margin-right:auto}.site__header--align-left .site__intro[data-v-6c8f1a5c]{margin-left:unset;margin-right:unset;font-size:.825rem}.site__location[data-v-6c8f1a5c]{font-size:.825rem}.site__location>*[data-v-6c8f1a5c]{align-items:center;color:inherit;display:inline-flex;gap:.25rem;text-decoration:none}.site__footer[data-v-6c8f1a5c]{bottom:0;left:0;padding-bottom:15px;position:absolute;width:100%;text-align:center}.site__footer-logo[data-v-6c8f1a5c]{color:var(--p-logo-fill);display:inline-flex;padding:3px 6px;text-decoration:none}.site__links[data-v-6c8f1a5c]{list-style:none;padding:0;position:relative;margin:0;margin-top:20px}.site-btn--loader[data-v-6c8f1a5c]{opacity:.6;width:100%}.site-btn--loader[data-v-6c8f1a5c]:focus,.site-btn--loader[data-v-6c8f1a5c]:hover{opacity:1}.site-btn--loader[data-v-6c8f1a5c]:disabled{cursor:none;opacity:.6}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-6c8f1a5c";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var PreviewProfile = __vue_component__;
export { PreviewProfile as default };